<template lang="pug">
  v-container
    v-row
      v-col
        v-list
          v-list-item(
            v-for="theme in themes"
            :key="theme.id")
            v-list-item-avatar
              v-img(
                :lazy-src="theme.image.srcLazy"
                :src="theme.image.src")
            v-list-item-content
              v-list-item-title {{ theme.name }}
            v-list-item-avatar(:color="theme.color")
            v-list-item-action.ml-3
              v-btn(
                @click="onClickEdit({ id: theme.id })"
                icon)
                v-icon {{ mdiPencil }}
            v-list-item-action
              v-btn(icon)
                v-icon {{ mdiDelete }}
</template>

<script>
import { page } from '@iez/core'
import data from '@iez/lib/data/'
import { mdiPlus, mdiPencil, mdiDelete } from '@mdi/js'
import router from '@iez/core/router'

const route = {
  name: `ManageThemes`,
  path: `/maange-themes`
}

export default {
  ...route,

  setup () {
    page.topBar.set({
      title: `Gestion des thèmes`
    })
    page.bottomShortcut.add({
      action: {
        label: `Ajouter un thème`,
        icon: mdiPlus,
        onClick: () => {
          router.push({
            name: `ManageThemesAdd`
          })
        }
      }
    })

    const themes = data.get({
      root: `themes`,
      fields: [
        `id`,
        `name`,
        `color`, {
          image: [
            `id`,
            `src`,
            `srcLazy`
          ]
        }
      ]
    })

    const onClickEdit = ({ id }) => {
      router.push({
        name: `ManageThemesAdd`,
        params: {
          id
        }
      })
    }

    return {
      themes,
      mdiPencil,
      mdiDelete,
      onClickEdit
    }
  }
}
</script>
